<template>
  <span>
    <FilterMenu :col="value" />
    <SaveFilteredView
      v-if="canCreateCustomView && hasFilteredTags"
      :view="customView" />
  </span>
</template>
<script>
import {
  mapState,
  mapGetters,
} from 'vuex';
import FilterMenu from './FilterMenu';
import SaveFilteredView from './SaveFilteredView';
export default {
  name: 'TableFilterTags',
  components: {
    FilterMenu,
    SaveFilteredView,
  },
  props: {
    value: {
      type: String,
      default: '',
    },
    canCreateCustomView: {
      type: Boolean,
      default: () => false,
    },
  },
  computed: {
    ...mapState(['role']),
    ...mapState('ScheduleViews', ['activeTags']),
    ...mapGetters('ScheduleViews', ['selectedView']),
    hasFilteredTags() {
      return this.activeTags && this.activeTags[this.value]?.length > 0;
    },
    activeTagsStr() {
      return JSON.stringify(this.activeTags);
    },
    customView() {
      if (!this.hasFilteredTags) {
        return null;
      }
      return {
        name: this.selectedView.name + ' - ' + this.truncatedArrayString(),
        id: this.selectedView.id,
        filterTag: this.activeTagsStr,
      };
    },
  },
  methods: {
    truncatedArrayString(maxLength = 30) {
      let res = '[';
      let currLength = 1;
      for (let [index, tag] of this.activeTags[this.value].entries()) {
        const remaining = maxLength - currLength;
        if (tag.length > remaining) {
          res += `'${tag.slice(0, remaining)}'` + '...';
        } else {
          res += `'${tag}'`;
          if (index < this.activeTags[this.value].length - 1) {
            res += ', ';
          }
        }
      }
      res += ']';
      return res;
    },
  },
};
</script>
